import React, {useEffect} from 'react';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as orderActions from '../../../_redux/orders/ordersActions';
import {Modal} from "react-bootstrap";
import {ModalProgressBar} from "../../../../../../_metronic/_partials/controls";
import {UseToast} from "../../../../../../_metronic/layout/_core/ToastProvider";


export function CardFinalizeOrderDialog({
    id, show, onHide
                                        }){
    const dispatch = useDispatch();

    const {toast, setToast} = UseToast();


    const {isLoading} = useSelector(
        (state) => ({isLoading: state.orders.actionsLoading}),
        shallowEqual
    );

    useEffect(() => {
        if(!id)
            onHide();
    }, [id]);

    useEffect(() => {
        
    }, [isLoading, dispatch]);
    
    const finalizeOrder = () =>{
        dispatch(orderActions.finalizeOrder({orderId: id})).then(() =>{
            onHide();
            setToast({
                header: 'سفارش ثبت شد.',
                body: 'نتیجه ثبت نهایی سفارش از طریق پیامک برای شما ارسال خواهد شد.',
                type: "success"
            });
        })
            .catch(error =>{
                setToast({
                    header: "خطایی رخ داد",
                    body: error.response.data.message,
                    type: "error"
                })
            })
    }
    
    return(
        <Modal
            show={show}
            onHide={onHide}
            >
            {isLoading && <ModalProgressBar variant={"query"}/> }
            <Modal.Header closeButton>
                <Modal.Title>
                    ثبت نهایی سفارش
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isLoading && (
                        <span>آیا از ثبت نهایی سفارش اطمینان دارید؟</span>
                    )}
                    {isLoading && (
                        <span>در حال ثبت نهایی سفارش...</span>
                    )}
                    <p className={"text-warning"}>لطفا تا زمان دریافت پاسخ و بسته شدن دیالوگ از بستن آن خودداری نمایید.</p>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <button
                            disabled={isLoading}
                            type={"button"}
                            onClick={onHide}
                            className={"btn btn-light btn-elevate"}>
                            لغو
                        </button>
                        <button
                            disabled={isLoading}
                            type={"button"}
                            onClick={finalizeOrder}
                            className={"btn btn-primary btn-elevate"}>
                            تایید
                        </button>
                    </div>
                </Modal.Footer>
        </Modal>
    )
}